module.exports = __webpack_public_path__ + "static/img/gp.abc62ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/en/gp.png
// module id = 8W7r
// module chunks = 1